import { render } from "./ConfirmDialogue.vue?vue&type=template&id=c8495f26"
import script from "./ConfirmDialogue.vue?vue&type=script&lang=js"
export * from "./ConfirmDialogue.vue?vue&type=script&lang=js"

import "./ConfirmDialogue.vue?vue&type=style&index=0&id=c8495f26&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__